import script from "./learning.vue?vue&type=script&setup=true&lang=js"
export * from "./learning.vue?vue&type=script&setup=true&lang=js"

import "./learning.vue?vue&type=style&index=0&id=fc9b04be&lang=scss"

const __exports__ = script;

export default __exports__